function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rating_svg__clip0_1_79)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.678 4.364h-.447A1.23 1.23 0 000 5.594v9.175A1.23 1.23 0 001.23 16h.448a1.23 1.23 0 001.231-1.23V5.593c0-.68-.55-1.23-1.23-1.23z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.636 9.117a.61.61 0 01.617-.614h1.675c.341 0 .617.285.617.614V16h-2.909V9.117z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.497 0h-.448c-.68 0-1.23.551-1.23 1.23v13.54c0 .679.55 1.23 1.23 1.23h.448c.68 0 1.23-.551 1.23-1.23V1.23c0-.679-.55-1.23-1.23-1.23z"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "rating_svg__clip0_1_79"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15v16H0z"
})));
function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgRating;